import React from "react";

import {
  faGraduationCap,
  faHandshake,
  faLandmark,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function OBAMissionComponent() {
  const missions = [
    {
      icon: faGraduationCap,
      title: "Educational Development",
      description:
        "Working closely with the school administration to identify, plan, and implement initiatives that contribute to the academic, infrastructural, and overall betterment of the school.",
    },
    {
      icon: faHandshake,
      title: "Strong Partnerships",
      description:
        "Building strong relationships with external organizations and partners to foster cooperation in executing programs that enhance education, promote sports development, and prepare students to meet global standards and future challenges.",
    },
    {
      icon: faLandmark,
      title: "Preserve Heritage",
      description:
        "Preserving and upholding the vision of the founders of Vidyaloka College while safeguarding the unique culture, values, and traditions that define the school's identity.",
    },
    {
      icon: faUsers,
      title: "Alumni Unity",
      description:
        "Connecting past students through events and activities that strengthen alumni relationships, encourage active participation, and preserve the rights and privileges of former students.",
    },
  ];

  return (
    <div
      className="rounded-3 border-vcg-muted p-4 p-lg-5 mb-5"
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-right"
    >
      <div className="mb-4">
        <h3 className="fw-bold">The Mission of the Old Boys' Association</h3>
      </div>

      <div className="row g-4">
        {missions.map((mission) => (
          <div className="col-md-6" key={mission.title}>
            <div
              className="border rounded-3 p-4 h-100 text-center"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <FontAwesomeIcon icon={mission.icon} size="3x" className="mb-3" />

              <h5 className="fw-bold">{mission.title}</h5>

              <p
                className="text-muted small mb-0"
                style={{
                  textAlign: "justify",
                  lineHeight: "1.7",
                }}
              >
                {mission.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
